import semver from 'semver'

export default defineNuxtPlugin({
  name: 'version',
  setup() {
    const { $api } = useNuxtApp()
    const { version: clientVersion } = useRuntimeConfig().public

    const systemStore = useSystemStore()
    const userStore = useUserStore()

    const checkVersion = async () => {
      const { version: serverVersion } = await $api('/version')
      return serverVersion
    }

    const isVersionCheckFlag = useFlag('switch.client.version-check')

    const isVersionCheckEnabled = computed(() => {
      return Boolean(isVersionCheckFlag.value && userStore.id)
    })

    const {
      data: serverVersion,
      pause,
      resume,
    } = usePolling(
      checkVersion,
      {
        immediate: false,
        immediateCallback: true,
      },
      60000
    )

    if (isVersionCheckEnabled.value) {
      resume()
    }

    watch(serverVersion, newServerVersion => {
      if (!newServerVersion) {
        systemStore.isVersionDrift = false
        return
      }

      systemStore.isVersionDrift = semver.gt(newServerVersion, clientVersion)
    })

    watch(isVersionCheckEnabled, isEnabled => {
      if (isEnabled) {
        resume()
      } else {
        pause()
        systemStore.isVersionDrift = false
      }
    })
  },
})
